import React, { useEffect } from 'react';
import { TextField } from '@material-ui/core';
import ICommonFormProps from '../interfaces/ICommonFormProps';
import { generateRegister } from '../utils';
import { DiscountCodeGenerator } from '../CustomFormComponents/DiscountCodeGenerator';

/**Form Input Generator  component */
const FormInputGenerator = (props: ICommonFormProps) => {
    useEffect(() => {
        if (props.value) {
            if (props.setValue) {
                props.setValue(props.keyName, props.value);
                props.triggerValidation!(props.keyName);
            }
        }
        // eslint-disable-next-line
    }, [props.value]);
    return (
        <TextField
            {...props.inputProperties}
            {...generateRegister(props)}
            style={{ width: '100%' }}
            disabled={props.disabled || false}
            label={props?.formProps?.overrideJSXLabel ? undefined : props.label}
            name={props.keyName}
            error={props.errors ? true : false}
            data-component-name={props.keyName}
            className={props.className}
            InputLabelProps={{ shrink: true }}
            variant={props.inputProperties?.variant || 'outlined'}
            InputProps={{
                endAdornment: props.formProps?.isEdit ? null : (
                    <DiscountCodeGenerator
                        setValue={props.setValue!}
                        triggerValidation={props.triggerValidation!}
                        className={props.formProps?.className}
                        keyName={props.keyName}
                    />
                ),
            }}
        />
    );
};

export default FormInputGenerator;
